import React from 'react'
import { Avatar } from '@chilipiper/design-system/src/new'
import { Box } from '@chilipiper/design-system'
import { useProfilePictureUrl } from '@chilipiper/user'
import { useFireSessionContext } from '@chilipiper/fire-session'
import { AvatarStatusVariant } from '@chilipiper/design-system/src/new/components/wayfinding/avatar-status/AvatarStatus'

export const CurrentUserAvatar = ({
  name,
  status,
}: {
  name: string
  status?: AvatarStatusVariant
}) => {
  const { userId } = useFireSessionContext()
  const { data: image } = useProfilePictureUrl(userId)
  return (
    <Box lineHeight={0}>
      <Avatar status={status} id={userId} name={name} size={4} image={image} />
    </Box>
  )
}
